/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { translate } from "@/src/services/translations/translations";
import React from "react";
import Typography from "@mui/material/Typography";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";

type SummaryDetailsItemProps = {
  caseData: Record<string, any>;
  fieldPath: string;
  value: string;
  labelPostfix?: string | null;
};

const SummaryDetailsItem = ({ caseData, fieldPath, value, labelPostfix = null }: SummaryDetailsItemProps) => {
  let label = translate(`${caseData.name}.${fieldPath}.label`, caseData);
  label = labelPostfix ? label + " " + labelPostfix : label;

  return (
    <>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={fieldPath} />
        {label}
      </Grid>
      <Grid size={12}>
        <Typography component="span" sx={{ textAlign: "center", mt: 5 }} dangerouslySetInnerHTML={{ __html: value }}></Typography>
      </Grid>
    </>
  );
};

export default SummaryDetailsItem;
